import { Email, SharedConfig, SHARED_CONFIG } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class EmailBuilder {
    constructor(@Inject(SHARED_CONFIG) private config: SharedConfig) {
        this.redirectFeedback = this.config.redirectFeedback;
    }

    public redirectEmails = ['via_test2@euromonitor.com'];

    protected redirectFeedback?: boolean;
    protected subject?: any;
    protected fromName?: any;
    protected fromEmail?: any;
    protected toEmail?: any;
    protected body?: any;

    public setEmail(value: Email): EmailBuilder {
        this.subject = value.subject;
        this.fromName = value.fromName;
        this.fromEmail = value.fromEmail;
        this.toEmail = value.toEmail;
        this.body = value.body;
        return this;
    }

    public setSubject(value: string | null): EmailBuilder {
        this.subject = value || this.feedbackMailSubjectTemplate(this.fromName);

        return this;
    }

    public feedbackMailSubjectTemplate = (fullCompanyName: any) => `User Feedback for ${fullCompanyName}`;

    public setFromName(value: string): EmailBuilder {
        this.fromName = value;
        return this;
    }

    public setFromEmail(value: string | null): EmailBuilder {
        this.fromEmail = value || Constants.SupportEmails.PORTAL_ADMIN_EMAIL;

        return this;
    }

    public setToEmail(value: string): EmailBuilder {
        this.toEmail = value;
        if (this.redirectFeedback) {
            this.redirectEmails.forEach((email) => (this.toEmail += `,${email}`));
        }
        return this;
    }

    public setBody(value: string): EmailBuilder {
        this.body = this.feedbackMailBodyTemplate(this.fromName, new Date().toLocaleString(), this.fromEmail, this.subject, value);

        return this;
    }

    public feedbackMailBodyTemplate = (fullCompanyName: any, feedbackDate: string, email: any, subject: any, feedback: string) =>
        `A user from ${fullCompanyName} has submitted feedback on ${feedbackDate}<br/>
        Sender  :  ${email}<br/>
        Subject :  ${subject}<br/>
        Feedback:<br/>
        ${feedback}`;

    public build(): Email {
        const fromEmail = 'Via-feedback@via.com';
        return new Email(this.subject, this.fromName, fromEmail, this.toEmail, this.body);
    }
}
